import { render, staticRenderFns } from "./supplierBudgetDetail.vue?vue&type=template&id=776f4ce9&"
import script from "./supplierBudgetDetail.vue?vue&type=script&lang=js&"
export * from "./supplierBudgetDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports